import { render, staticRenderFns } from "./lower_right_corner.vue?vue&type=template&id=25a179ab&scoped=true&"
import script from "./lower_right_corner.vue?vue&type=script&lang=js&"
export * from "./lower_right_corner.vue?vue&type=script&lang=js&"
import style0 from "./lower_right_corner.vue?vue&type=style&index=0&id=25a179ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a179ab",
  null
  
)

export default component.exports